import React, { Component } from "react";
import "./App.scss";
import { Row, Col, Tabs } from "antd";

import golomt_logo from "./images/golomt_logo.png";
import banner from "./images/banner.jpg";
import bannerMobile from "./images/banner_mobile.png";
import POSIndevTab from "./tabs/POS-indiv";
import POSCorpTab from "./tabs/POS-corp";
import EcomTab from "./tabs/Ecom";

const { TabPane } = Tabs;



class App extends Component {
  render() {
    return (
      <Row>
        <header>
          <a
            href="http://www.golomtbank.com/?__hstc=233546881.310b73b383628488da77e55bb2cdece8.1584945846705.1584945846705.1584945846705.1&__hssc=233546881.3.1584945846707&__hsfp=1902021915"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={golomt_logo} className="golomt_logo" />
          </a>
        </header>
        <div className="top-image" />

        <div className="main">
          <Tabs defaultActiveKey="1" type="card">
            <TabPane
              style={{ marginLeft: 0 }}
              tab="КҮБ хувь хүн"
              key="1"
              className="title1"
            >
              <div>
                <p className="wrapper"></p>
                <Row style={{ display: "flex", justifyContent: "center" }}>
                  <Col
                    xxl={20}
                    xl={20}
                    md={20}
                    sm={24}
                    xs={24}
                    className="card-features"
                  >
                    <Col style={{ display: "flex", justifyContent: "center" }}>
                      <Col xxl={16} xl={16} md={16} sm={24} xs={24}>
                        <POSIndevTab />
                      </Col>
                    </Col>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <p className="copyright">
                      &copy; Golomt Bank, All rights reserved
                    </p>
                  </Col>
                </Row>
              </div>
            </TabPane>
            <TabPane
              style={{ marginLeft: 0 }}
              tab="КҮБ байгууллага"
              key="2"
              className="title1"
            >
              <div>
                <p className="wrapper"></p>
                <Row style={{ display: "flex", justifyContent: "center" }}>
                  <Col
                    xxl={20}
                    xl={20}
                    md={20}
                    sm={24}
                    xs={24}
                    className="card-features"
                  >
                    <Col style={{ display: "flex", justifyContent: "center" }}>
                      <Col xxl={16} xl={16} md={16} sm={24} xs={24}>
                        <POSCorpTab />
                      </Col>
                    </Col>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <p className="copyright">
                      &copy; Golomt Bank, All rights reserved
                    </p>
                  </Col>
                </Row>
              </div>
            </TabPane>
            <TabPane
              style={{ marginLeft: 0 }}
              tab="И-КҮБ"
              key="3"
              className="title1"
            >
              <div>
                <p className="wrapper">
                  <strong></strong>
                </p>

                <Row style={{ display: "flex", justifyContent: "center" }}>
                  <Col
                    xxl={20}
                    xl={20}
                    md={20}
                    sm={24}
                    xs={24}
                    className="card-features"
                  >
                    <Col style={{ display: "flex", justifyContent: "center" }}>
                      <Col xxl={16} xl={16} md={16} sm={24} xs={24}>
                        <EcomTab />
                      </Col>
                    </Col>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <p className="copyright">
                      &copy; Golomt Bank, All rights reserved
                    </p>
                  </Col>
                </Row>
              </div>
            </TabPane>
          </Tabs>
        </div>
      </Row>
    );
  }
}

export default App;
